import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import ProjectLinks from 'src/app/common/project.links';
import { FullUser } from 'src/app/swagger-api';
import { ViewProfileState } from '../view-profile.state';

@Component({
  selector: 'app-owner-profile',
  templateUrl: './owner-profile.component.html',
  styleUrls: ['./owner-profile.component.scss'],
})
export class OwnerProfileComponent extends ViewProfileState implements OnChanges {
  @Input({ required: true }) public user: FullUser;

  public readonly LINK_PROFILE_EDIT: string = ProjectLinks.LINK_PROFILE_EDIT;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['user']) {
      this.isProfileUncompleted(this.user);
    }
  }
}
